import StoresSettingsTable from "components/Preferences/StoresSettings/StoresSettingsTable.tsx";
import { useContext, useEffect, useState } from "react";
import * as Styles from "pages/Preferences/Stores/AllStoresAdminPage.styles.ts";
import { AllStoresHeaderText } from "components/Preferences/text.ts";
import { useGetUserDetailsQuery } from "features/api/userApi.ts";
import { useLazyGetManageableStoresQuery } from "features/api/storesApi.ts";
import ConfigurationsContext from "context/configurations/ConfigurationsContext.ts";
import APIErrorCustomBanner from "components/Common/APIErrorCustomBanner/APIErrorCustomBanner.tsx";
import { UserPermission } from "types/declarations/enums.ts";
import { models } from "types/api/viewModels.ts";

const AllStoresAdminPage = () => {
	const [triggerManageableStores] = useLazyGetManageableStoresQuery();
	const { data: userDetails, isLoading: isUserDetailsLoading } = useGetUserDetailsQuery();
	const isAdmin = userDetails?.permissions?.find((x) => x === UserPermission.ADMIN) ?? false;
	const [availableStores, setAvailableStores] = useState<models["StoreSettingsPageViewModel"][] | null | undefined>();
	const [loading, setLoading] = useState(true);
	const { configurationsData } = useContext(ConfigurationsContext);
	const isUserPreferenceEnabled = configurationsData?.featureFlags?.userPreferenceEnabled ?? false;

	useEffect(() => {
		if (isUserDetailsLoading || !isAdmin || !isUserPreferenceEnabled) {
			return;
		}

		setLoading(true);
		triggerManageableStores()
			.unwrap()
			.then((stores) => setAvailableStores(stores))
			.catch(() => {
				// Error is handled by setting loading to false
				// Component will render with undefined availableStores
			})
			.finally(() => setLoading(false));
	}, [triggerManageableStores, isAdmin, isUserDetailsLoading, isUserPreferenceEnabled]);

	if (isUserDetailsLoading) {
		return (
			<>
				<Styles.StoresSettingLandingPageHeader>
					<h1>{AllStoresHeaderText}</h1>
				</Styles.StoresSettingLandingPageHeader>
				<Styles.StoresContainer>
					<StoresSettingsTable
						isLoading
						stores={undefined}
					/>
				</Styles.StoresContainer>
			</>
		);
	}

	if (!isAdmin || !isUserPreferenceEnabled) {
		return (
			<div>
				<APIErrorCustomBanner statusCode={403} />
			</div>
		);
	}

	return (
		<>
			<Styles.StoresSettingLandingPageHeader>
				<h1>{AllStoresHeaderText}</h1>
			</Styles.StoresSettingLandingPageHeader>
			<Styles.StoresContainer>
				<StoresSettingsTable
					isLoading={loading}
					stores={availableStores}
				/>
			</Styles.StoresContainer>
		</>
	);
};

export default AllStoresAdminPage;
